import request from "@/utils/request";

// 获取地址
export function getRegionList(params) {
    return request({
      url: "/getRegionList",
      method: "GET",
      params
    });
}


/**
 * 导入列表
 * @param {*} type 类型 1考生导入 2试题导入
 * @returns
 */
 export function getBatchList(params) {
  return request({
    url: "/getBatchList",
    method: "GET",
    params,
  });
}

/**
 * 下载错误文件
 * @param {*} batch_id
 * @returns
 */
 export function downloadErrorBatchList(params) {
  return request({
    url: "/downloadErrorBatchList",
    method: "GET",
    params,
    header: {
      headers: {'Content-Type': 'application/x-download'},
    },
    responseType: "blob", 
  });
}

// 获取机构列表
export function getAgencyList() {
  return request({
    url: "/getAgencyList",
    method: "get",
  });
}



/**
 * 获取通知列表
 * @param {*} 
 * @returns
 */
 export function getNoticeList(params) {
  return request({
    url: "/getNoticeList",
    method: "get",
    params
  });
}

/**
 * 获取通知
 * @param {*} id 
 * @returns
 */
export function getNotice(params) {
  return request({
    url: "/getNotice",
    method: "get",
    params
  });
}


/**
 * 获取考试相关通知列表
 * @param {is_read} 是否已读  1是 0否 -1所有
 * @returns
 */
export function getExamineeNoticeList(params) {
  return request({
    url: "/getExamineeNoticeList",
    method: "get",
    params
  });
}

/**
 * 获取考试相关通知
 * @param {*} id 
 * @returns
 */
export function getExamineeNotice(params) {
  return request({
    url: "/getExamineeNotice",
    method: "get",
    params
  });
}

/**
 * 获取服务器时间
 * @param {*} 
 * @returns
 */
export function getServerTime(params) {
  return request({
    url: "/getServerTime",
    method: "GET",
    params,
  });
}

/**
 * 保存前端报错信息
 * @param {*} exam_paper_id
 * @param {*} topic_list
 * @returns
 */
 export function saveFrontEndErrorMessage(data) {
  return request({
    url: "/saveFrontEndErrorMessage",
    method: "POST",
    data,
  });
}